export const columns: any[] = [
  {
    name: 'videoId',
    title: 'ID',
  },
  {
    name: 'originalname',
    title: 'Name',
  },
  {
    name: 'cdn',
    title: 'URL',
  },
  {
    name: 'copyUrl',
    title: 'Copy Url',
  },
  { name: 'delete', title: '' },
];
